import { makeAutoObservable, runInAction } from "mobx";
import RootStore from "../../../stores/RootStore";

export default class ProductCategoriesStore {
    // Observables
    isLoading = false;
    error: string | null = null;
    categories: any[] = [];
    currentCategory: any = null;

    // Constructor
    constructor(private rootStore: RootStore) {
        makeAutoObservable(this);
    }

    // Actions
    setLoading(loading: boolean) {
        this.isLoading = loading;
    }

    setError(error: string | null) {
        this.error = error;
    }

    // Async actions
    async loadCategories() {
        try {
            this.setLoading(true);
            this.setError(null);

            // Mock data for now
            const mockCategories = [
                {
                    id: "cat-1",
                    name: "Wall Panels",
                    description: "Precast wall panels",
                    productCount: 25,
                },
                {
                    id: "cat-2",
                    name: "Floor Panels",
                    description: "Precast floor panels",
                    productCount: 15,
                },
            ];

            runInAction(() => {
                this.categories = mockCategories;
            });
        } catch (error: any) {
            runInAction(() => {
                this.setError(error.message || "Failed to load categories");
            });
        } finally {
            this.setLoading(false);
        }
    }

    // Computed values
    get hasCategories() {
        return this.categories.length > 0;
    }
}
